import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45d0720a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45d0720a&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=45d0720a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d0720a",
  null
  
)

export default component.exports